import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { PlatformService } from 'app/core/services/platform.service';
import { ModalsService } from '../modals.service';

@Component({
  standalone: false,
  selector: 'modal-soft-update',
  templateUrl: 'modal-soft-update.component.html',
  styleUrls: ['modal-soft-update.component.scss'],
})
export class ModalSoftUpdateComponent {
  constructor(
    private modal: ModalController,
    private platformService: PlatformService,
    private modalService: ModalsService,
  ) {}

  onCancelBtnClick() {
    this.modal.dismiss();
  }

  onReminderBtnClick() {
    this.modal.dismiss();
  }

  onUpdateBtnClick() {
    if (!this.platformService.isCordova()) {
      this.modal.dismiss();
      return;
    }

    this.modalService.openUpdateLink();
    this.modal.dismiss();
  }
}
